import httpClient from '../../shared/services/httpClient';

export const SearchEvent = async () => {
  return await httpClient.get(`/eventtype/all`, { skipAuth: true });
};
